/**
 * Generated bundle index. Do not edit.
 */

export * from './index';

export {createEffectInstances as ɵa} from './lib/akita-ng-effects.module';
export {EffectsFeatureModule as ɵg} from './lib/effect-feature.module';
export {ModuleManager as ɵf} from './lib/module-manager.service';
export {FEATURE_EFFECT_INSTANCES as ɵe,ROOT_EFFECT_INSTANCES as ɵc,_FEATURE_EFFECTS as ɵd,_ROOT_EFFECTS as ɵb} from './lib/tokens';